//触发埋点
export default url => {
  window.dataLayer.push({
    event: "trackPageView",
    url,
    locale: "zh-cn",
    userId: "",
    token: "",
    isVip: null,
    visitTimes: "",
    visitDuration: "",
    usingDuration: "",
    appVersion: "1.0.0",
    adblock: null,
    specialContent: null,
    product: "h5-app",
    host: document.location.host,
    apiKey: "fotor"
  });
};
